import { HomeOutlined, MessageOutlined } from '@ant-design/icons';
import useAuth from '@hooks/use-auth';
import useDocumentTitle from '@hooks/use-document-title';
import { Role } from '@interfaces/role';
import { Button, Result } from 'antd';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './NotFound.module.scss';

const NotFound: FC = () => {
  useDocumentTitle('Page not found');
  const navigate = useNavigate();
  const auth = useAuth();
  const isAdmin = auth.hasRole(Role.Admin);
  const homePath = isAdmin ? '/management' : '/chat/conversations';
  const homeLabel = isAdmin ? 'Go to Management' : 'Go to Conversations';

  return (
    <div className={styles.notFound}>
      <Result
        status="404"
        title="Page not found"
        subTitle="The page you requested does not exist."
        extra={
          <Button
            type="primary"
            icon={isAdmin ? <HomeOutlined /> : <MessageOutlined />}
            onClick={() => navigate(homePath)}
          >
            {homeLabel}
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
